<template>
  <div class="store">
    <van-nav-bar :title="title" fixed border>
      <template #left>
        <img src="../../../assets/img/icon/left-arrow.png" class="icon" @click="goBack()" />
      </template>
    </van-nav-bar>
    <div class="collapse">
    	<div class="empty" v-if="items.length==0">
			<span class="msg">暂无店铺</span>
		</div>
		<div class="col-item" v-for="(item, index) in items" :key="index" @click="goStoreInfo(item.s_id)" v-else>
			<div class="msg">
			  <div class="topic">
			<img :src="attach_url+item.s_img" alt />
			<span class="title">{{item.s_name}}</span>
			  </div>
			  <span class="time">{{item.create_time*1000|moment_format('Y-MM-DD')}}</span>
			</div>
			<div class="content industry">{{item.s_type}}</div>
			<div class="content location">{{item.s_address}}</div>
			<div class="content label" v-if="item.s_step==0">
			审核中
				<van-button type="primary" @click.stop="toNextStep(item.s_id,item.s_step)">历史审核</van-button>
			</div>
			<div class="content label" v-else-if="item.s_step==1">
				审核通过
				<van-button type="primary" @click.stop="toNextStep(item.s_id,item.s_step)">上传环境图</van-button>
			</div>
			<div class="content label" v-else-if="item.s_step==2">
				审核通过
				<van-button type="primary" @click.stop="toNextStep(item.s_id,item.s_step)">绑定银行账户</van-button>
			</div>
			<div class="content label" v-else-if="item.s_step==3">
				审核通过
				<van-button type="primary" @click.stop="toNextStep(item.s_id,item.s_step)">产品管理</van-button>
				<van-button type="primary" @click.stop="toNextStep(item.s_id,4)">公告配送</van-button>
			</div>
			<div v-else>
				<div class="content label">
					{{item.s_status==1?(item.s_close_by==2?'休业中...':(item.s_close_by==1?'系统休业':'营业中...')):(item.s_status==2?'审核未通过':(item.s_status==99?'系统停业':'审核中'))}}
					<span class="time" style="margin-left:5px;" v-if="item.s_close_by!=0">[ {{item.s_close_from*1000|moment_format('Y-MM-DD HH:mm:ss')}} ~ {{item.s_close_to*1000|moment_format('Y-MM-DD HH:mm:ss')}} ]</span>
				</div>
				<div class="content">
					<van-button type="primary" @click.stop="toActivity(item.s_id)">活动管理</van-button>
					<van-button type="primary" @click.stop="toStoreOrder(item.s_id)">订单管理</van-button>
					<van-button type="primary" @click.stop="toNextStep(item.s_id,3)">产品管理</van-button>
					<van-button type="primary" @click.stop="toManage(item,index)">店铺管理</van-button>
				</div>
			</div>
			<div class="content van-multi-ellipsis--l2">
				{{item.s_summary}}
			</div>
		</div>

		<van-button type="primary" block @click="goStoreInfo()" style="margin:50px auto;width:90%" v-if="items.length==0||userInfo.u_level>0">我要入驻</van-button><!--  -->
    </div>

    <van-popup v-model="showProcess" position="bottom" :style="{ 'max-height': '80%' }">
		<van-steps direction="vertical" :active="0">
		  <van-step v-for="(item, index) in processList" :key="index">
			<h3>{{item.l_content}}</h3>
			<p>{{item.create_time*1000|moment_format('Y-MM-DD HH:mm:ss')}}</p>
		  </van-step>
		</van-steps>
	</van-popup>

	<van-popup v-model="showUploader" position="bottom">
		<van-divider>请上传3张小于500Kb的环境图</van-divider>
		<van-uploader multiple :max-size="imgSizeLimit" @oversize="onOversize" max-count="3" v-model="imgList" :before-read="beforeRead" />
		
		<van-button type="primary" block :disabled="imgList.length!=3" @click="uploadStoreEnv()" >上传</van-button>
    </van-popup>

    <van-popup v-model="showAccount" position="bottom">
		<van-divider>请绑定银行账号，方便收款</van-divider>
		<van-cell-group>
			<van-field
				v-model.trim="account.name"
				label="持卡人："
				placeholder="请输入持卡人姓名"
				required
				clearable
			></van-field>
			<van-field
				v-model.trim="account.card"
				label="卡号："
				placeholder="请输入银行卡号"
				required
				clearable
			></van-field>
			<van-field
				v-model.trim="account.bank"
				label="开户银行："
				placeholder="请输入银行名称"
				required
				clearable
			></van-field>
			<van-field
				v-model.trim="account.address"
				label="银行地址："
				placeholder="请输入银行地址"
				clearable
			></van-field>
		</van-cell-group>
		
		<van-button type="primary" block :disabled="!(account.name&&account.bank&&account.card)" @click="bindAccount()" >绑定</van-button>
    </van-popup>

	<van-popup v-model="showStoreManage" position="bottom" :style="{ 'height': '80%' }">

		<van-tabs v-model="manageTabActive">
			<van-tab title="营业/公告"></van-tab>
			<van-tab title="配送资费"></van-tab>
			<van-tab title="环境图"></van-tab>
			<van-tab title="结账账号"></van-tab>
		</van-tabs>
		<div style="padding:10px">
			<van-cell-group v-if="manageTabActive==0">
				<van-field v-model="common.notice" maxlength="100" label="公告内容：">
				</van-field>
				<van-cell title="系统休业：" :value="closeDate" v-if="closeBy==1"/>
				<van-cell title="休业日期：" :value="closeDate" @click="init2pickerDateTime" v-else>
					<template #right-icon><van-button type="default" plain hairline size="mini" @click.stop="emptyCloseDate" :style="{'margin-left':'5px'}">清空</van-button></template>
				</van-cell>
				<van-button type="primary" block @click="saveBusiness()" >保存</van-button>
				<van-notice-bar left-icon="info-o" v-if="closeBy!=1" :style="{'margin-top':'10px'}">
					休业期间暂停接单
				</van-notice-bar>
			</van-cell-group>

			<div v-if="manageTabActive==1">

				<van-cell-group>
					<van-field v-model="express.min_order_amount" type="number" label="最低：">
						<template #button>元起送</template>
					</van-field>
				</van-cell-group>

				<van-cell-group>
					<van-field v-model="express.free" type="number" label="免费送：">
						<template #button>公里内</template>
					</van-field>
				</van-cell-group>

				<van-cell-group>
					<van-field v-model="express.markup" type="number" label="加价送：">
						<template #button>公里内</template>
					</van-field>
					<van-field v-model="express.markup_amount" type="number" label="每公里加收：">
						<template #button>元</template>
					</van-field>
				</van-cell-group>

				<van-divider>
					快递收费
					<van-icon name="add" @click="addExpress"  color="#ff0000" :style="{'margin-left':'10px'}"/>
					<van-icon name="clear" @click="expressList=[]"  color="#ff0000" :style="{'margin-left':'10px'}"/>
				</van-divider>

				<van-cell-group v-for="(exp, ind) in expressList" :key="ind" :style="{display:'flex'}">
					<van-field v-model="exp.distance" type="number" label="" :style="{width:'50%'}">
						<template #button>公里内</template>
					</van-field>
					<van-field v-model="exp.amount" type="number" label="" :style="{width:'50%'}">
						<template #button>元</template>
					</van-field>
				</van-cell-group>

				<van-cell-group>
					<van-field v-model="express.markup_max" type="number" label="最高收费：">
						<template #button>元</template>
					</van-field>
				</van-cell-group>
				<div style="display:flex;">
					<van-button type="default" block @click="express={};expressList=[]" :style="{width:'41%','margin':'1% 3% 1% 6%'}">重置</van-button>
					<van-button type="primary" block @click="saveExpress()"  :style="{width:'41%','margin':'1% 6% 1% 3%'}">保存</van-button>
				</div>
			</div>

			<van-cell-group v-if="manageTabActive==2">
				<van-divider>请上传3张小于500Kb的环境图</van-divider>
				<van-uploader multiple :max-size="imgSizeLimit" @oversize="onOversize" max-count="3" v-model="imgList" :before-read="beforeRead"/>
				<van-button type="primary" block :disabled="imgList.length!=3" @click="uploadStoreEnv()" >上传</van-button>
			</van-cell-group>

			<van-cell-group v-if="manageTabActive==3">
				<van-cell title="持卡人：" :value="account.name" ></van-cell>
				<van-cell title="卡号：" :value="account.card" ></van-cell>
				<van-cell title="开户银行：" :value="account.bank" ></van-cell>
				<van-cell title="银行地址：" :value="account.address" ></van-cell>
				<van-notice-bar left-icon="info-o" :style="{'margin-top':'10px'}">
					账号信息修改请联系客服！
				</van-notice-bar>
			</van-cell-group>
		</div>
    </van-popup>

	<van-calendar v-model="showCloseDate" type="range" @confirm="onConfirmCloseDate" />

	<van-popup v-model="showCloseDateTimePopup" position="bottom">
		<van-datetime-picker
			type="datetime"
			:title="closeDateTimeTitle"
			:min-date="new Date()"
			@confirm="onConfirmCloseDateTime"
			@cancel="showCloseDateTimePopup=false"
		/>
	</van-popup>

  </div>
</template>

<script type="text/ecmascript-6">
import { chkImgType } from "@/utils/common.js";
import { Collapse, CollapseItem, Step, Steps,Divider, Calendar,DatetimePicker } from "vant";

export default {
	name: "store",
	components: {
		"van-collapse": Collapse,
		"van-collapse-item": CollapseItem,
		"van-step":Step,
		"van-steps":Steps,
		"van-divider":Divider,
		"van-calendar":Calendar,
		"van-datetime-picker":DatetimePicker
	},
	data() {
		return {
			title: "店铺管理",
			attach_url:this.Conf.serverPre,
			items: [],
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			showProcess:false,
			processList:[],
			showUploader:false,
			imgList:[],
			imgSizeLimit:500 * 1024,
			cur_s_id:-1,
			showAccount:false,
			userInfo:{},
			account:{name:'',card:'',bank:'',address:''},
			showStoreManage:false,
			express:{},
			expressList:[],
			common:{},
			curManageInd:-1,
			manageTabActive:0,
			showCloseDate:false,
			closeBy:0,
			closeDateSel:[],
			closeDate:'',
			showCloseDateTimePopup:false,
			closeDateTimeTitle:'',
			showCloseDateTime:0,
			closeDateTimeFrom:null,
			closeDateTimeTo:null
		};
	},
	mounted() {
		// 获取浏览器可视区域高度
		this.winH = `${document.documentElement.clientHeight}`;
		window.onresize = function temp() {
			this.winH = `${document.documentElement.clientHeight}`;
		};
	},
	created() {
		this.getStateConfigs();
		this.loadData();
		if(localStorage.getItem("userInfo")){
			this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
			this.account.name = this.userInfo["u_name"];
		}
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		goBack() {
			this.$router.push({
				name: "My",
				query: {
				  active: 3,
				}
			});
		},
		loadData() {
			var params = {
				u_id: this.u_id,
				token: this.token
			};
			var url = this.Conf.serverUrl + "UserStore/myStores" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				this.items = response.data.stores;
			})
			.catch(error => {});
		},
		goStoreInfo(s_id) {
			this.$router.push({
				name: "StoreInfo",
				query:{s_id:s_id}
			});
		},
		toNextStep(s_id, step){
			this.cur_s_id = s_id;
			switch(step){
				case 1:
					this.showUploader = true;
					break;
				case 2:
					this.showAccount = true;
					break;
				case 3:
					this.$router.push({
						path: "StoreGoods/"+s_id
					});
					break;
				case 4:
					this.showStoreManage = true;
					this.getExpress();
					break;
				default:
					this.showProcess = true;
					this.getProcess();
					break;
			}
			return false;
		},
		toManage(item,i){
			this.curManageInd = i;
			this.cur_s_id = item.s_id;
			this.showStoreManage = true;
			this.getExpress();
			this.closeDate = '';
			if(item.s_close_by!=0){
				this.closeDate = this.$options.filters['moment_format'](item.s_close_from*1000,'Y-MM-DD HH:mm:ss') + '~' + this.$options.filters['moment_format'](item.s_close_to*1000,'Y-MM-DD HH:mm:ss');
			}
			
		},
		toActivity(s_id){
			this.$router.push({
				path: "StoreActivity/"+s_id
			});
		},
		toStoreOrder(s_id){
			this.$router.push({
				path: "StoreOrder/"+s_id
			});
		},
		beforeRead(file){
			return chkImgType(file);
		},
		uploadStoreEnv(){
			if(this.imgList.length != 3){
				this.$toast.fail("环境图必须为3张且大小不能超过500kb");
				return false;
			}
			var formData = new window.FormData();
			formData.append('s_id',this.cur_s_id);
			formData.append('u_id',this.u_id);
			formData.append('token',this.token);
			let newupload = false;
			for(var i in this.imgList){
				if(this.imgList[i].content){
					formData.append('img_'+(parseInt(i)+1),this.imgList[i].content);
					newupload = true;
				}else{
					let phs = this.imgList[i].path.split("/");
					formData.append('img_'+(parseInt(i)+1), phs[phs.length-1]);
				}
			}
			if(!newupload){
				this.$toast.fail("请重新上传或替换环境图！");
				return false;
			}

			var url = this.Conf.serverUrl + "UserStore/uploadStoreImg" + "?num=" + Math.random();
			let that = this;
			that.$axios
			.post(url, formData, { "Content-Type": "multipart/form-data" })
			.then(response => {
				if (response.data.msg) {
					that.$toast.success(response.data.msg);
				}
				if(response.data.code == 200){
					that.showUploader = false;
					that.loadData();
				}
			})
			.catch(error => {});
		},
		bindAccount(){
			var params = {
				u_id: this.u_id,
				token: this.token,
				s_id:this.cur_s_id,
				account:this.account
			};
			let that = this;
			var url = this.Conf.serverUrl + "UserStore/bindAccount" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				if (response.data.msg) {
					that.$toast.success(response.data.msg);
				}
				if(response.data.code == 200){
					that.showAccount = false;
					that.loadData();
				}
			})
			.catch(error => {});
		},
		getProcess(){
			var params = {
				u_id: this.u_id,
				token: this.token,
				s_id:this.cur_s_id,
			};
			let that = this;
			var url = this.Conf.serverUrl + "UserStore/process" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				if(response.data.code == 40001){
					this.$toast.fail(response.data.msg);
					return false
				}
				this.processList = response.data.logs;
			})
			.catch(error => {});
		},
		onOversize(){
			this.$toast.fail("图片大小不能超过 500kb");
		},
		addExpress(){
			this.$set(this.expressList,this.expressList.length,{});
			console.log(this.expressList)
		},
		getExpress(){
			var params = {
				u_id: this.u_id,
				token: this.token,
				s_id:this.cur_s_id,
			};
			let that = this;
			var url = this.Conf.serverUrl + "UserStore/express" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				this.express = response.data.express['express'];
				this.expressList = (this.express.expressList)?this.express.expressList:[];
				this.common = response.data.express['common'];
			})
			.catch(error => {});
		},
		saveExpress(){
			this.$dialog
			.confirm({
				title: "配送资费",
				message: "确定保存当前配置吗？",
			})
			.then(() => {
				
				var params = {
					u_id: this.u_id,
					token: this.token,
					s_id:this.cur_s_id,
					express:this.express
				};
				params.express.expressList = this.expressList;
				let that = this;
				var url = this.Conf.serverUrl + "UserStore/saveExpress" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						//that.showStoreManage = false;
					}
				})
				.catch(error => {});
				
			})
			.catch((error) => {});
			return false;
		},
		saveBusiness(){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定保存当前配置吗？",
			})
			.then(() => {
				
				var params = {
					u_id: this.u_id,
					token: this.token,
					s_id:this.cur_s_id,
					common:this.common,
					colseDate:this.closeDate
				};
				let that = this;
				var url = this.Conf.serverUrl + "UserStore/saveBusiness" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						//that.showStoreManage = false;
						if(that.closeDateSel.length==2){
							that.items[that.curManageInd].s_close_by = 2;
							//that.items[that.curManageInd].s_close_from = that.closeDateSel[0]/1000;
							//that.items[that.curManageInd].s_close_to = that.closeDateSel[1]/1000;
							that.items[that.curManageInd].s_close_from = that.closeDateTimeFrom/1000;
							that.items[that.curManageInd].s_close_to = that.closeDateTimeTo/1000;

						}
					}
				})
				.catch(error => {});
				
			})
			.catch((error) => {});
			return false;
		},
		getAttrs(t){
			var params = {
				u_id: this.u_id,
				token: this.token,
				s_id:this.cur_s_id,
				type:t
			};
			let that = this;
			var url = this.Conf.serverUrl + "UserStore/attrs" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				if(response.data.code == 200){
					let rdatas = response.data.datas;
					if(response.data.type == 1){// 环境图
						that.imgList = [];
						for(var i in rdatas){
							that.imgList.push({url:that.attach_url+rdatas[i].a_note,path:rdatas[i].a_note});
						}
					}else if(response.data.type == 2){// 结账信息
						that.account = {};
						for(var i in rdatas){
							that.account[rdatas[i].a_title] = rdatas[i].a_note;
						}
					}
				}
			})
			.catch(error => {});
		},
		emptyCloseDate(){
			this.closeDate='';
			this.closeDateSel = [];
			this.$forceUpdate();
		},
		onConfirmCloseDate(date) {
			this.closeDateSel = date;
			const [start, end] = date;
			this.showCloseDate = false;
			this.closeDate = this.$options.filters['moment_format'](start.getTime(),'Y-MM-DD') + '~' + this.$options.filters['moment_format'](end.getTime(),'Y-MM-DD');
		},
		init2pickerDateTime(){
			this.closeDateTimeTitle = '休业开始时间';
			this.showCloseDateTimePopup = true;
			this.showCloseDateTime = 1;
		},
		onConfirmCloseDateTime(val){
			this.showCloseDateTimePopup = false;
			if(this.showCloseDateTime==2){
				this.closeDateTimeTo = val;
				this.closeDate += this.$options.filters['moment_format'](val.getTime(),'Y-MM-DD HH:mm:00');
				this.showCloseDateTime=0;
			}else{
				this.closeDateTimeFrom = val;
				this.closeDate = this.$options.filters['moment_format'](val.getTime(),'Y-MM-DD HH:mm:00') + '~';
				setTimeout(()=>{
					this.closeDateTimeTitle = '休业结束时间';
					this.showCloseDateTimePopup = true;
					this.showCloseDateTime=2;
				},500);
			}
			this.$forceUpdate();
		}
	},
	watch:{
		manageTabActive(){
			if(this.manageTabActive>1){
				this.getAttrs(this.manageTabActive==2?1:2);
			}
		}
	}
};
</script>




// WEBPACK FOOTER //
// src/components/My/Store/StoreManage.vue